<template>
  <base-card :projectID="projectID" :categoryID="categoryID" :storyType="storyType" :isMarginless="isMarginless" :isRowLoading="isRowLoading" :isPinnableRow="isPinnableRow" :pinnedProjects="pinnedProjects" :disableLink="disableLink" :isGroupProject="isGroupProject">
    <information :isRowLoading="isRowLoading" :isBlank="isBlank">
      <h1 class="card-heading">{{ cardHeading }}</h1>
    </information>
    <project-title :isRowLoading="isRowLoading" :isBlank="isBlank" :title="title" :elementID="elementID" />
    <project-image :image="image" :isRowLoading="isRowLoading" :imageBackground="imageBackground" :isBlank="isBlank" :isVisible="isVisible" :projectAwards="project.awards" :imageOverlay="imageOverlay">
    </project-image>
    <milestone-progress v-if="postMilestoneCount" :milestonePostCount="postMilestoneCount" :completedPostCount="postCompletedCount"/>
  </base-card>
</template>

<script>
import BaseCard from './BaseCard'
import base from '../mixins/base'
import visibility from '@/mixins/visibility'
import ProjectTitle from '../UI/Title'
import Information from '../UI/Information'
import ProjectImage from '../UI/ProjectImage'
import VisibilityFlags from '@/components/Cards/ProjectCards/UI/visibilityFlags'
import MilestoneProgress from '../UI/MilestoneProgress'

export default {
  name: 'Project',
  components: {
    BaseCard,
    ProjectTitle,
    Information,
    ProjectImage,
    VisibilityFlags,
    MilestoneProgress
  },
  props: ['projectID', 'categoryID', 'storyType', 'isMarginless', 'isRowLoading', 'isPinnableRow', 'pinnedProjects', 'disableLink', 'isGroupProject', 'cardHeading'],
  mixins: [base, visibility],
  computed: {
    showCategories: function () {
      return this.$isYSC || (this.project.categories && this.project.categories.length > 0 && (!this.$isBroadcomMasters && !this.$isGirlsAndSteam))
    },
    postMilestoneCount: function () {
      return this.$store.getters.getPostCounts[this.projectID] && this.$store.getters.getPostCounts[this.projectID].milestonePostCount
    },
    postCompletedCount: function () {
      return this.$store.getters.getPostCounts[this.projectID] && this.$store.getters.getPostCounts[this.projectID].completedPostCount
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .card-heading {
    font-family: "Roboto";
    font-size: 0.8rem;
    color: black;
    font-weight: 200;
    padding: 1rem 0 0 1rem;
    text-transform: uppercase;
  }

  ::v-deep {
    .main-container .story-title {
      height: 44px;
      @include mobile {
        height: 40px;
      }
    }
    .main-container .story-title {
      height: 3.4rem !important;
      margin-top: 0 !important;
    }
    .background-overlay {
      display: none !important;
    }
    .image.overlay-exist {
      background-size: cover;
    }
  }
</style>
